import numeral from 'numeral'
export const formatNum = (amount: any) => numeral(amount).format('0,0')
export const formatNumber = (amount: any) => {
  if (amount) {
    const string = amount.toString()
    const [n, decimal] = string.split('.')
    return formatNum(n || 0) + numeral('0.' + decimal).format('.[00]')
  }
  return 0
}

export const formattedNumber = (value: number): string => {
  return value
    .toFixed(2)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export const formatAmountNumber = (num: number) =>
  num
    ? num.toLocaleString('en-US', {
        minimumFractionDigits: 6,
        maximumFractionDigits: 6,
      })
    : 0
